import { PortalRoutes } from "@lyteflo/types";
import { useMemo } from "preact/compat";
import { useLocation } from "wouter";

interface UseNotificationVisibilityOptions {
  excludedRoutes?: string[];
}

export const useNotificationVisibility = (
  options: UseNotificationVisibilityOptions = {},
) => {
  const [path] = useLocation();

  const defaultExcludedRoutes = [
    PortalRoutes.WIDGET_OWNERSHIP_REPORT,
    PortalRoutes.WIDGET_UNSUBSCRIBE,
    PortalRoutes.BATTERY_REPORT,
    PortalRoutes.BATTERY_REPORT_PUBLIC,
    PortalRoutes.PUBLIC_NOT_FOUND,
  ];

  const excludedRoutes = options.excludedRoutes || defaultExcludedRoutes;

  const excludedBasePaths = useMemo(
    () => excludedRoutes.map((route: string) => route.split("/:")[0]),
    [excludedRoutes],
  );

  const isVisible = useMemo(() => {
    if (path === PortalRoutes.BATTERY_REPORTS) {
      return true;
    }

    // Check if path starts with any excluded base path
    return !excludedBasePaths.some((base: string) => path.startsWith(base));
  }, [excludedBasePaths, path]);

  return {
    isVisible,
    excludedBasePaths,
    currentPath: path,
  };
};
